// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vuex from 'vuex'
import store from './store/store'
import '../static/ueditor/ueditor.config';
import '../static/ueditor/ueditor.all.min';
import '../static/ueditor/lang/zh-cn/zh-cn';
import '../static/ueditor/ueditor.parse.min';
import 'babel-polyfill' 
import $ from 'jquery'
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)
import 'swiper/dist/css/swiper.css'

// import remConfig from './config/rem'
Vue.use(VueAwesomeSwiper)

// remConfig()
Vue.config.productionTip = false
import axios from 'axios'
Vue.prototype.$http = axios;
// axios.defaults.baseURL = 'https://api.treegroup-inc.com/';
axios.defaults.baseURL = 'https://api.treegroup-inc.com/';
// axios.interceptors.request.use((config) => {
//   if (localStorage.getItem('Authorization')) {
//     config.headers.Authorization = localStorage.getItem('Authorization');
//   }
//   return config;
// });
//路由守卫
router.beforeEach((to, from, next) => {
  let token = localStorage.getItem('user_token');
  if (token) {
    next()
  } else {
    if ( to.path ==  '/backHome' 
        ||to.path == '/welcome'
        ||to.path == '/backVideo'
        ||to.path == '/backContact'
        ||to.path == '/backSEO'
        ||to.path == '/backChongyi'
        ||to.path == '/backChildren'
        ||to.path == '/backPatriarch'
        ||to.path == '/backPolitical'
        ||to.path == '/backInform'
        ||to.path == '/backNews'
        ||to.path == '/backRecipe'
        ||to.path == '/backRecruit'
        ||to.path == '/backBanner'
        ||to.path =='/backChildren/ueditor'
        ||to.path =='/backPatriarch/ueditor'
        ||to.path =='/backPolitical/ueditor'
        ||to.path =='/backInform/ueditor'
        ||to.path =='/backNews/ueditor'
        ||to.path == '/backRecipe/ueditor'
        ||to.path =='/backRecruit/ueditor'
      ) {
      next({path: '/backLogin'})
    } else {
     
      next()
    }
  }
});
// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  let token = localStorage.getItem('user_token')
  if (token) {
    config.headers['Authorization'] = token
  }
  return config
}, function (error) {
  return Promise.reject(error)
})
//动态设置SEO
var title;
var describe;
var label;
axios.post('/api/dashu/seo/seoList', {
}).then( (res)=> {

var code=res.data.code;
if(code===0){
  // console.log(res.data.data.contact)
   title=res.data.data.contact.title
   describe=res.data.data.contact.describe
   label=res.data.data.contact.label
   var str=label.join(",")
   document.querySelector('meta[name="keywords"]').setAttribute('content', str)
   document.title =title || '大树'
   document.querySelector('meta[name="description"]').setAttribute('content', describe)
}
}).catch(function (error) {
//  console.log(error);
});

Vue.use(Element);
Vue.use(Vuex)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,

  components: { App },
  template: '<App/>'
})
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});




// WEBPACK FOOTER //
// ./src/main.js